import React from 'react'
import Plyr from './plyr'

const Video = ({ video }) => {

  const getVideoID = (url) => {
    if (!url) return null
    let regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    let match = url.match(regExp)
    return match && match.length > 1 && match[1]
  }

  return (
    <div className='post__video'>
      <Plyr
        type="youtube"
        videoId={getVideoID(video)}
        urls={{
          youtube: {
            api: `https://noembed.com/embed?url=${0}`
          }
        }}
      />
    </div>
  )
}

export default Video